import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './components/home/home.component';
import { TranslateModule } from '@ngx-translate/core';

//PRIMENG - No borrar
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { MenuModule } from 'primeng/menu';
import { TooltipModule } from 'primeng/tooltip';

//PRIMENG - programador

//COMPONENTS
import { HomeMenuButtonsComponent } from '../base/components/home-menu-buttons/home-menu-buttons.component';
import { SharingService } from '../project/services/sharing.service';
import { ToastModule } from 'primeng/toast';
import { AprobadoComponent } from './components/aprobado/aprobado.component';
import { RechazadoComponent } from './components/rechazado/rechazado.component';
import { RedirectComponent } from './components/redirect/redirect.component';
import { ErrorRetornoComponent } from './components/error-retorno/error-retorno.component';
import { ErrorWebpayComponent } from './components/error-webpay/error-webpay.component';

@NgModule({
    declarations: [HomeComponent, HomeMenuButtonsComponent, AprobadoComponent, RechazadoComponent, RedirectComponent, ErrorRetornoComponent, ErrorWebpayComponent],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        CommonModule,
        //PRIMENG
        ButtonModule,
        InputTextModule,
        TableModule,
        OverlayPanelModule,
        MenuModule,
        TooltipModule,
        ToastModule
    ],
    providers: [SharingService]
})
export class ProjectModule { }
